<div class="ev-card address-panel" data-testid="address-panel-container">
    <app-search data-testid="address-panel-search" (searchChanged)="searchChangedHandler($event)"
    [inputValue]="inputValue ? inputValue : ''" [failedPlan]="false" [addressSearch]="true">
    </app-search>
    <div class="address-panel-buttons">
    <button class="ev-button primary" data-testid="address-panel-save-btn" (click)="save()">{{ languageService.languageJSON.Global_Save }}</button>
    <button class="ev-button" data-testid="address-panel-back-btn" (click)="goBack()">{{ languageService.languageJSON.Global_Back }}</button>
    </div>
</div>